import { render } from "./ForgetPasswordConfirm.vue?vue&type=template&id=f31247a4&scoped=true"
import script from "./ForgetPasswordConfirm.vue?vue&type=script&lang=js"
export * from "./ForgetPasswordConfirm.vue?vue&type=script&lang=js"

import "./ForgetPasswordConfirm.vue?vue&type=style&index=0&id=f31247a4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f31247a4"],['__file',"src/views/ForgetPasswordConfirm.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f31247a4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f31247a4', __exports__)) {
    api.reload('f31247a4', __exports__)
  }
  
  module.hot.accept("./ForgetPasswordConfirm.vue?vue&type=template&id=f31247a4&scoped=true", () => {
    api.rerender('f31247a4', render)
  })

}


export default __exports__